import { render, staticRenderFns } from "./HandleTicketModal.vue?vue&type=template&id=665b0635&scoped=true"
import script from "./HandleTicketModal.vue?vue&type=script&lang=js"
export * from "./HandleTicketModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b0635",
  null
  
)

export default component.exports